module.exports = __webpack_public_path__ + "static/cover-mockup-no-bg-52be2d3eba4d73797974a683df40faf8.jpg";